import { SapMasterProductsAdd } from "../../features"

const SapMasterProductsAddPage = () => {
  return <SapMasterProductsAdd />
}

export default SapMasterProductsAddPage
